import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import Header from "./Header";
import { normalize } from "common/lib/normalize";
import { getAgency } from "common/services/agencies.service";
import { useParams } from "react-router-dom";
import Widgets from "./Widgets";
import AgencyPayments from "./AgencyPayments";
import BreadCrumb from "Components/Common/BreadCrumb";

const ViewAgency = () => {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);

  const { id: agencyId } = useParams();

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAgency(agencyId, {
        populate: ["createdby", "updatedby", "payments", "category"],
      });
      setData(normalize(response.data));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [agencyId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <BreadCrumb
              title="Reporting Agency Details"
              pageTitles={[
                {
                  title: "Dashboard",
                  link: "/",
                },
                { title: "Reporting Agencies", link: "/reporting-agencies" },
              ]}
              back
            />

            <Header agency={data} loading={loading} />
          </Row>
          <Row>
            <Col xxl={12}>
              <Widgets />
              <AgencyPayments mda={data} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewAgency;
